// extracted by mini-css-extract-plugin
export default {"companyContainer":"xM-z","companyImage":"yM-z","container":"zM-z","heading":"AM-z","darkText":"BM-z","smallHeading":"CM-z","darkBackground":"DM-z","whiteBackground":"EM-z"};